import React from "react";
import * as uuid from "uuid";
import { TripsReportsRow } from "../../../api/models/TripsReportsRow";
import {
    LoadingTableElement,
    NullTableElement,
} from "../../../components/table/nullTable";
import { Order } from "../../../components/table/sort";
import {
    ChangePageCond,
    ChangeSortCond,
    SortableTable,
} from "../../../components/table/sortableTable";
import { convertNeedGuidanceToCheckMark } from "../../../services/common/convert";
import { store } from "../../../store";
import { convertBoardingType } from "../../../utils/formatting";
import { reserveTripsSlice } from "../store";
import { Row, headCells } from "./ColumnsTrip";

export const convertTripReportsToDataTableFormat = (
    tripReportsList?: TripsReportsRow[] | null
): Row[] => {
    if (!tripReportsList) {
        return [];
    }

    const _data = tripReportsList.map((rec: TripsReportsRow) => {
        const ng = convertNeedGuidanceToCheckMark(rec.needGuidance);
        return {
            need_guidance: convertNeedGuidanceToCheckMark(rec.needGuidance),
            unladen_start_time: rec.unladenStartTs,
            unladen_start_city: rec.unladenStartCity,
            deliver_start_time: rec.boardingTs,
            deliver_start_city: rec.boardingCity,
            unladen_time: rec.unladenSec,
            wheel_time: rec.handleTime,
            pause_car_request_sec: rec.pauseCarRequestSec,
            boarding_type: convertBoardingType(rec.boardingType),
            navi_off_time: rec.naviOffSec,
            deviation_count: rec.deviationCount,
            go_cancel_count: rec.goCancelCount,
            deboarding_time: rec.deliverTs,
            deboarding_city: rec.deliverCity,
            is_hermes_off: rec.isHermesOff,
            navi_off_sec: rec.naviOffSec,
            is_deviation: rec.isDeviation,
            is_go_cancel: rec.isGoCancel,
            trip: rec,
            trip_session_id: rec.tripSessionId,
            login_session_id: rec.loginSessionId,
            row_id: uuid.v4(),
        } as Row;
    });
    return _data;
};

interface TableProps {
    trips?: TripsReportsRow[] | null;
}

export const TripsTable: React.FC<TableProps> = (props: TableProps) => {
    if (!props.trips) {
        return <LoadingTableElement />;
    }

    if (props.trips.length == 0) {
        return <NullTableElement />;
    }
    const _data = convertTripReportsToDataTableFormat(props.trips);

    // ソート条件を保持するコールバック関数
    const callbackS: ChangeSortCond = (key: string, order: Order): void => {
        store.dispatch(
            reserveTripsSlice.actions.update_sort_cond([key, order])
        );
    };
    // 表示しているページを保持するコールバック関数
    const callbackP: ChangePageCond = (no: number, numRows: number): void => {
        store.dispatch(
            reserveTripsSlice.actions.update_page_cond([no, numRows])
        );
    };

    const dc = store.getState().reserveTrips.displayCond;
    return (
        <SortableTable
            tableHeaders={headCells}
            tableData={_data}
            tableProps={props}
            displayCond={dc}
            rowIdField={"row_id"}
            onRowClickMethod={() => {}}
            slimRows={true}
            callbackChangeSortCond={callbackS}
            callbackChangePageCond={callbackP}
        />
    );
};
